import { IS_NOT_EMPTY } from 'cargo-chief-commons';
import { DataMap } from '@domain/interface/data-map';
import { Header } from '@domain/interface/header';

export const ACCEPTED_DATE_FORMATS = [
	'M/D/YYYY',
	'M-D-YYYY',
	'YYYY-M-D',
	'YYYY/M/D',
	'MM/DD/YYYY',
	'MM-DD-YYYY',
	'YYYY-MM-DD',
	'YYYY/MM/DD',
	// 2-digit year variants (e.g. 07/02/26) — moment resolves YY to the 2000s.
	// Slash-only: the backend parser (ParseDateFromCSV) accepts M/d/yy & MM/dd/yy
	// but has no dash + 2-digit-year format, so we don't allow those here.
	'M/D/YY',
	'MM/DD/YY',
];

export const MAP_HEADERS = (headers: string[]) => {
	let headerMap = {};

	headers.forEach(function (header, headerIndex) {
		let key = header.toLowerCase().trim();
		headerMap[key] = headerIndex;
	});

	return headerMap;
};

export const MAP_INDICES = (headers: string[]) => {
	let indicesMap = {};

	headers.forEach(function (header, headerIndex) {
		let value = header.toLowerCase().trim();
		indicesMap[headerIndex] = value;
	});

	return indicesMap;
};

export const IS_EMPTY_LINE = (line: string): boolean => {
	let isEmpty = true;

	if (line && line.length > 0) {
		let lineSplit: string[] = line.split(',');
		lineSplit.forEach((column) => {
			if (column && IS_NOT_EMPTY(column.trim())) {
				isEmpty = false;
			}
		});
	}
	return isEmpty;
};

export const GET_MISSING_FIELDS = (line: string, indicesMap: {}, requiredHeaders: string[]) => {
	let rowElements = line.split(',');
	let missingFields = [];

	// ignore blank line
	if (rowElements.length == 0) {
		return missingFields;
	}

	for (var i = 0; i < rowElements.length; i++) {
		if (requiredHeaders.includes(indicesMap[i]) && !rowElements[i]) {
			missingFields.push(indicesMap[i]);
		}
	}
	return missingFields;
};

export const GET_HEADERS_MAP = (dataMap: DataMap, dataType: string): Header[] => {
	return dataMap[dataType].headersMap;
};

export const GET_REQUIRED_HEADERS = (dataMap: DataMap, dataType: string) => {
	return dataMap[dataType].requiredHeaders;
};

export const GET_FILE_DATA_VALIDATOR = (dataMap: DataMap, dataType: string) => {
	return dataMap[dataType].fileDataValidator;
};

export const GET_FORM_GROUP = (dataMap: DataMap, dataType: string) => {
	return dataMap[dataType].formGroupBuilder();
};

export const GET_BUCKET_NAME = (dataMap: DataMap, dataType: string): string => {
	return dataMap[dataType].fileUploadBucketName;
};

export const IS_VALID_LINE = (line: string, indicesMap: {}, requiredHeaders: string[]) => {
	let isValid = true;
	let rowElements = line.split(',');
	let requiredHeaderCount = requiredHeaders.length;

	// ignore blank line
	if (rowElements.length > 1 && rowElements.length < requiredHeaderCount) {
		isValid = false;
	}

	if (isValid && rowElements.length > 1) {
		for (var i = 0; i < rowElements.length; i++) {
			if (requiredHeaders.includes(indicesMap[i]) && !rowElements[i]) {
				isValid = false;
				break;
			}
		}
	}

	return isValid;
};

export const DOWNLOAD_FILE = (s3Url: string) => {
	const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', s3Url);
    document.body.appendChild(link);
    link.click();
    link.remove();
}
